import { render, staticRenderFns } from "./listcart.vue?vue&type=template&id=5b037c19&"
import script from "./listcart.vue?vue&type=script&lang=js&"
export * from "./listcart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports